import axios from 'axios'
import { getToken } from '../localStoreage'

class HttpModule {
  constructor() {
    this.http = axios.create()
    this.http.headers = { 'Content-Type': 'application/json' }
    this.baseUrl = process.env.REACT_APP_API_URL
    this.token = ''
    this.resource = ''
    this.body = {}
    this.query = {}

    this.http.interceptors.response.use(
      function (response) {
        return response
      },
      function (error) {
        if (error.response.status === 401) {
          localStorage.clear()
          console.error('unauthorized error: ', error)
          if (error?.response?.data?.service === 'api/signin') {
            return
          }
          window.location.href = '/login'
        }
        const result = {
          method: error.response.data.method,
          service: error.response.data.service,
          status: error.response.status,
          statusText: error.response.statusText,
          message: [...error.response.data.message],
        }
        console.error('g-error:', { ...result })
        return Promise.reject(result)
        return Promise.reject(JSON.stringify(result))
      },
    )
  }

  assembleRequestHeader() {
    this.http.defaults.headers.common = {}
    this.token = getToken()
    this.http.defaults.headers.common = {
      Authorization: `bearer ${this.token}`,
    }
  }

  validateUrl() {
    if (this.baseUrl.length <= 0) {
      throw Error('It is necessary to enter a url for the request to be executed.')
    }
  }

  setHeader(value) {
    this.http.headers = { ...this.http.headers, ...value }
  }

  setHeaderAndClear(value) {
    this.http.headers = { ...value }
  }

  getMyToken() {
    this.http.defaults.headers.common = {}
    this.token = getToken()
    this.http.defaults.headers.common = { Authorization: `bearer ${this.token}` }
  }

  setBaseUrl(value) {
    this.baseUrl = value
  }

  setResource(value) {
    this.resource = value
  }

  setBody(value) {
    this.body = value
  }

  setQuery(value) {
    this.query = value
  }

  async get() {
    this.validateUrl()
    this.assembleRequestHeader()
    let result = {}
    result = await this.http.get(`${this.baseUrl}${this.resource}`, {
      params: this.query,
    })
    return result
  }

  async post() {
    let result = {}
    this.validateUrl()
    this.assembleRequestHeader()
    result = await this.http.post(`${this.baseUrl}${this.resource}`, this.body, {
      params: this.query,
    })
    return result
  }

  async patch() {
    let result = {}
    this.validateUrl()
    this.assembleRequestHeader()
    await this.http.patch(`${this.baseUrl}${this.resource}`, this.body, {
      params: this.query,
    })
    return result
  }

  async put() {
    let result = {}
    this.validateUrl()
    this.assembleRequestHeader()
    result = await this.http.put(`${this.baseUrl}${this.resource}`, this.body, {
      params: this.query,
    })
    return result
  }

  async delete() {
    let result = {}
    this.validateUrl()
    this.assembleRequestHeader()
    result = await this.http.delete(`${this.baseUrl}${this.resource}`, this.body, {
      params: this.query,
    })
    return result
  }
}

export default HttpModule
